import { chatBotFeature } from "./chat/ChatBotFeature";
import { IFeature } from "./iFeature";
import { imageGenerationFeature } from "./image-generation/ImageGenerationFeature";
import { summaryFeature } from "./summary/SummaryFeature";
import { transcriptionFeature } from "./transcription/TranscriptionFeature";
import { translationFeature } from "./translation/TranslationFeature";

export const registeredFeatures: IFeature[] = [
  chatBotFeature,
  summaryFeature,
  transcriptionFeature,
  translationFeature,
  imageGenerationFeature,
];
